module.exports = __webpack_public_path__ + "img/PC_Logo2.26a72e80.png";